<template>
    <!-- Główny kontener widoku HomeView -->
    <div class="users content-container flex-column">
      <div class="content-wrap">
  
        <!-- Sekcja z tytułem "Dewiacja kalibracji" i komponentem kalibracji -->
        <div class="d-flex users-section-container">
        <div class="users-section">
          <!-- Nagłówek sekcji: wyświetla przetłumaczony tekst kalibracji -->
          <!-- <span>{{ t('calibration-deviation') }}</span> -->
          <span>{{ t('calibration-deviation') }}</span>
          <FilterCalibrationData />
        </div>
          <div class="content-wrap">
            <!-- Pasek narzędzi (przełącznik mapy) i pasek akcji są w samym
                 komponencie — widok nie dokłada tu pustego paska. -->
            <CalibrationDeviation />
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import CalibrationDeviation from "@/components/CalibrationDeviation"; // import komponentu kalibracji
import FilterCalibrationData from "@/components/FilterCalibrationData";
// import moment from "moment"; // biblioteka do pracy z datami

export default {
  name: "CalibrationDeviationView",
  components: {
    CalibrationDeviation,
    FilterCalibrationData,
  },
};
</script>

<style scoped>
/* Kontener sekcji użytkowników i zawartości */
.users-section-container {
  width: 100%;
}

/* Pasek filtrów po lewej stronie (tło z obrazkiem) */
.users-section {
  width: var(--sidebar-width);
  background: var(--surface-secondary);
}

/* Stylowanie nagłówka sekcji (span wewnątrz .users-section) */
.users-section > span {
  padding: var(--spacing-md) var(--spacing-lg);
  position: relative;
  display: block;
}

/* Stylowanie tytułu <h3> w .content-wrap */
.content-wrap h3 {
  background-color: var(--surface-primary);
  padding: var(--spacing-md) var(--spacing-lg);
  margin-bottom: 0;
  position: relative;
}

/* Styl przycisku wewnątrz <h3> (jeśli będzie użyty) */
h3 button {
  position: absolute;
  right: 20px;
  top: 17%;
  background-color: var(--surface-selected);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  min-height: 28px;
  font-size: var(--font-size-sm);
  padding: 0;
  border: 0;
}

/* Pozostałe ikony i stany collapse */
.no-content {
  min-height: auto;
}
.icon {
  margin: 5px;
  height: 15px;
  width: 35px;
}
.icon-collapse {
  background: url("../assets/icons/zwin.png") no-repeat left top;
  width: 19px;
  height: 19px;
  position: absolute;
  cursor: pointer;
  right: 10px;
}
.collapsed.icon-collapse {
  background: url("../assets/icons/rozwin.png") no-repeat left top;
}

</style>
